import { render, staticRenderFns } from "./PagePartnerError.vue?vue&type=template&id=3f49b9ec"
import script from "./PagePartnerError.vue?vue&type=script&lang=js"
export * from "./PagePartnerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports